import { add } from 'date-fns';
import { TierPeriod } from 'features/premium/entities';
import { getStripeProduct } from './entities';
export const INTRO_GIFT_PROMOTION_ID = -1;
export const INTRO_GIFT_WINDOW_HOURS = 24;
const NULL_OFFERING = {
    ios1mProduct: null,
    ios1mDiscount: null,
    ios1mOfferId: null,
    android1mProduct: null,
    android1mDiscount: null,
    android1mTag: null,
    ios12mProduct: null,
    ios12mDiscount: null,
    ios12mOfferId: null,
    android12mProduct: null,
    android12mDiscount: null,
    android12mTag: null,
    stripe1mProduct: null,
    stripe1mDiscount: null,
    stripe1mCouponId: null,
    stripe1mDiscountPeriods: null,
    stripe1mDiscountPrice: null,
    stripe6mProduct: null,
    stripe6mDiscount: null,
    stripe6mCouponId: null,
    stripe6mDiscountPeriods: null,
    stripe6mDiscountPrice: null,
    stripe12mProduct: null,
    stripe12mDiscount: null,
    stripe12mCouponId: null,
    stripe12mDiscountPeriods: null,
    stripe12mDiscountPrice: null,
};
/**
 * Builds a full Promotion from ab_intro_gift_feed
 */
export const buildIntroGiftPromotion = ({ offer, firstConnectionAt, stripePriceMap, feedCardDismissedAt, }) => {
    const product = getStripeProduct(stripePriceMap, offer.productId);
    if (!product) {
        return null;
    }
    const connectionDate = new Date(firstConnectionAt);
    const availableFrom = connectionDate.toISOString();
    const availableTo = add(connectionDate, {
        hours: INTRO_GIFT_WINDOW_HOURS,
    }).toISOString();
    const discountFraction = offer.discount / 100;
    const stripeSlots = product.period === TierPeriod.yearly
        ? {
            stripe12mProduct: offer.productId,
            stripe12mDiscount: discountFraction,
            stripe12mCouponId: offer.couponId,
            stripe12mDiscountPeriods: offer.periods,
            stripe12mDiscountPrice: offer.discountPrice,
        }
        : {
            stripe1mProduct: offer.productId,
            stripe1mDiscount: discountFraction,
            stripe1mCouponId: offer.couponId,
            stripe1mDiscountPeriods: offer.periods,
            stripe1mDiscountPrice: offer.discountPrice,
        };
    return {
        id: INTRO_GIFT_PROMOTION_ID,
        availableFrom,
        availableTo,
        fullScreenSeenAt: null,
        feedCardDismissedAt: feedCardDismissedAt
            ? new Date(feedCardDismissedAt).toISOString()
            : null,
        acceptedAt: null,
        offering: {
            id: INTRO_GIFT_PROMOTION_ID,
            freeTrialDays: null,
            ...NULL_OFFERING,
            ...stripeSlots,
        },
    };
};
